import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const UserEditContactSuccess = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!state) {
      navigate("/home", { replace: true });
    }
  }, []);

  // Helper to format name nicely
  const formatName = (first, last) => {
    const full = [first, last].filter(Boolean).join(" ").trim();
    return full
      ? full
          .toLowerCase()
          .split(" ")
          .map(
            (word) =>
              word.charAt(GlobalConfiguration.lengthCheckZero).toUpperCase() +
              word.slice(GlobalConfiguration.lengthCheckOne),
          )
          .join(" ")
      : "—";
  };

  const user = state?.user?.employees?.[GlobalConfiguration.lengthCheckZero];

  const buttonRows = [
    [
      {
        btnText: "Create new user",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: () => navigate("/settings/users/create_user"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: () => {
          navigate(`/settings/user_view_all/user_detail_page/${user?.id}`);
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: () => navigate("/home"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      //   status="success"
      //   title="User Updated successfully."
      //   subtitle="Contact details have been updated"
      //   buttonRows={buttonRows}
      //   hoverOption="black"
      isLoading={false}
      status="success"
      hoverOption="white"
      title={"User’s details updated successfully."}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection title="User details">
        <>
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: formatName(
                  state?.user?.employees[GlobalConfiguration.lengthCheckZero]
                    ?.first_name +
                    " " +
                    state?.user?.employees[GlobalConfiguration.lengthCheckZero]
                      ?.last_name,
                ),
                leftSubTitle: "User name",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle:
                  state?.user?.employees[GlobalConfiguration.lengthCheckZero]
                    ?.user_id,
                leftSubTitle: "User ID",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle:
                  state?.user?.employees[GlobalConfiguration.lengthCheckZero]
                    ?.alias_name || "N/A",
                leftSubTitle: "Alias",
              },
            ]}
          />

          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle:
                  state?.user?.employees[GlobalConfiguration.lengthCheckZero]
                    ?.mob_no,
                leftSubTitle: "Contact number",
              },
            ]}
          />

          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle:
                  state?.user?.employees[GlobalConfiguration.lengthCheckZero]
                    ?.email_id,
                leftSubTitle: "Email ID",
              },
            ]}
          />

          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle:
                  state?.user?.employees[GlobalConfiguration.lengthCheckZero]
                    ?.grade,
                leftSubTitle: "Grade",
              },
            ]}
          />
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default UserEditContactSuccess;
